import { useEffect } from 'react'

import { Consultation } from '@/core/models/consultation.model'

import { useAppDispatch } from '@/redux/rootReducer'
import { getConsultation, joinConsultationSocketEvent, leaveConsultationSocketEvent } from '@/redux/reducers/consultation.reducer'

type UseEmergencyConsultationLifecycleParams = {
  emergencyConsultation?: Consultation
  emergencyConsultationId?: string
}

export function useEmergencyConsultationLifecycle({
  emergencyConsultation,
  emergencyConsultationId,
}: UseEmergencyConsultationLifecycleParams) {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!emergencyConsultationId) return

    if (!emergencyConsultation) {
      dispatch(getConsultation(emergencyConsultationId))
    }

    dispatch(joinConsultationSocketEvent(emergencyConsultationId))

    return () => {
      dispatch(leaveConsultationSocketEvent(emergencyConsultationId))
    }
  }, [dispatch, emergencyConsultationId, emergencyConsultation])
}
